module.exports = __webpack_public_path__ + "static/media/student-refund-mob.bd7a302a.png";